function list2select(id, width, title) {
    var list = id;
    if (list.length){
        list.menutron({
            maxScreenWidth: width,
            menuTitle: title
        });
    }
}